import UserHeader from "./UserHeader";
import AdminHeader from "./AdminHeader";

interface Props {
  role: "customer" | "admin" | string;
}

const MainHeader = ({ role }: Props) => {
  return <>{role === "customer" ? <UserHeader /> : <AdminHeader />}</>;
};

export default MainHeader;
